import React from 'react';
import ServicesEditTemplate from './services-edit-template'

const TemporaryVisaService = () => {
    return <ServicesEditTemplate doc="temporary_visa" service="Temporary Visa" />;
};

export default TemporaryVisaService;
